import { useSelector } from "react-redux";
import { useProjectsByCustomerId } from "../../../fnx/projectsByCustomerId";
var useSelectors = function (clientId, trigger, sponsorId) {
    var _a = useProjectsByCustomerId(clientId, trigger, "", "", sponsorId), responseSponsor = _a.responseSponsor, errorSponsor = _a.errorSponsor, loadingSponsor = _a.loadingSponsor, responseInsurance = _a.responseInsurance, loadingInsurance = _a.loadingInsurance, errorInsurance = _a.errorInsurance;
    var _b = useSelector(function (state) { return ({
        responseCancelPolicy: state.Policy.responseCancelPolicy,
        loadingCancelPolicy: state.Policy.loadingCancelPolicy,
        errorCancelPolicy: state.Policy.errorCancelPolicy,
    }); }), responseCancelPolicy = _b.responseCancelPolicy, loadingCancelPolicy = _b.loadingCancelPolicy, errorCancelPolicy = _b.errorCancelPolicy;
    var _c = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _c.responseDeleteEntity, loadingDeleteEntity = _c.loadingDeleteEntity, errorDeleteEntity = _c.errorDeleteEntity;
    var _d = useSelector(function (state) { return ({
        responseCancelQuote: state.CancelQuote.responseCancelQuote,
        loadingCancelQuote: state.CancelQuote.loadingDeleteEntity,
        errorCancelQuote: state.CancelQuote.errorDeleteEntity,
    }); }), responseCancelQuote = _d.responseCancelQuote, loadingCancelQuote = _d.loadingCancelQuote, errorCancelQuote = _d.errorCancelQuote;
    var _e = useSelector(function (state) { return ({
        responsePlan: state.Plan.responsePlan,
        errorPlan: state.Plan.errorPlan,
        loading: state.Plan.loadingPlan,
    }); }), responsePlan = _e.responsePlan, errorPlan = _e.errorPlan, loading = _e.loading;
    var _f = useSelector(function (state) {
        var _a;
        return ({
            responseProject: (_a = state.Project.responseProject) === null || _a === void 0 ? void 0 : _a.data,
            errorProject: state.Project.errorProject,
            loadingProject: state.Project.loadingProject,
        });
    }), responseProject = _f.responseProject, errorProject = _f.errorProject, loadingProject = _f.loadingProject;
    var _g = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogStatusQuote: (_a = state.Catalog.responseGetCatalogStatusQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorGetCatalogStatusQuote: state.Catalog.errorGetCatalogStatusQuote,
            loadingGetCatalogStatusQuote: state.Catalog.loadingGetCatalogStatusQuote,
        });
    }), responseGetCatalogStatusQuote = _g.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _g.errorGetCatalogStatusQuote, loadingGetCatalogStatusQuote = _g.loadingGetCatalogStatusQuote;
    var _h = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _h.responseAllQuote, errorAllQuote = _h.errorAllQuote, loadingAllQuote = _h.loadingAllQuote;
    var _j = useSelector(function (state) {
        var _a;
        return ({
            responseBranches: (_a = state.Branches.responseBranches) === null || _a === void 0 ? void 0 : _a.data,
            errorBranches: state.Branches.errorBranches,
            loadingBranches: state.Branches.loadingBranches,
        });
    }), responseBranches = _j.responseBranches, errorBranches = _j.errorBranches, loadingBranches = _j.loadingBranches;
    var _k = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _k.responseOneQuote, errorOneQuote = _k.errorOneQuote, loadingOneQuote = _k.loadingOneQuote;
    return {
        responseCancelPolicy: responseCancelPolicy,
        loadingCancelPolicy: loadingCancelPolicy,
        errorCancelPolicy: errorCancelPolicy,
        responseDeleteEntity: responseDeleteEntity,
        loadingDeleteEntity: loadingDeleteEntity,
        errorDeleteEntity: errorDeleteEntity,
        responseCancelQuote: responseCancelQuote,
        loadingCancelQuote: loadingCancelQuote,
        errorCancelQuote: errorCancelQuote,
        responsePlan: responsePlan,
        errorPlan: errorPlan,
        loading: loading,
        responseProject: responseProject,
        errorProject: errorProject,
        loadingProject: loadingProject,
        responseGetCatalogStatusQuote: responseGetCatalogStatusQuote,
        errorGetCatalogStatusQuote: errorGetCatalogStatusQuote,
        loadingGetCatalogStatusQuote: loadingGetCatalogStatusQuote,
        responseAllQuote: responseAllQuote,
        errorAllQuote: errorAllQuote,
        loadingAllQuote: loadingAllQuote,
        responseBranches: responseBranches,
        errorBranches: errorBranches,
        loadingBranches: loadingBranches,
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
        responseSponsor: responseSponsor,
        errorSponsor: errorSponsor,
        loadingSponsor: loadingSponsor,
        responseInsurance: responseInsurance,
        loadingInsurance: loadingInsurance,
        errorInsurance: errorInsurance,
    };
};
export default useSelectors;
